module.exports = __webpack_public_path__ + "img/login_logo.39216ee5.png";